// extracted by mini-css-extract-plugin
export default {"instapayInfo":"instapay_instapayInfo__Yniux"};